import "bootstrap/dist/css/bootstrap.css";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./custom.css";

//Analytics
import ReactGA from "react-ga";

//Translations
import "./i18nextConf";

// MSAL imports
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { MsalProvider } from "@azure/msal-react";

//const
const msalInstance = new PublicClientApplication(msalConfig);
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
ReactGA.initialize("UA-143758729-1");

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  </MsalProvider>,
  rootElement
);

registerServiceWorker();
